<cue-declarative-map-marker pane="portal" className="my-portal-icon" [geoJson]="geoJson()">
  <div
    *cueDeclarativeMapMarkerTemplate
    class="map-portal-host"
    (click)="onHostClick($event)"
    [style.transform]="'scale(' + scale() + ')'"
    [style.-webkit-transform]="'scale(' + scale() + ')'"
  >
    @if (portalPoint()) {
      <div class="poiWrapper" #poiWrapper>
        @if (portalPoint().name | localizedString) {
          <div class="map-btn-name" [class.isNextPortal]="!isFirstPortalOfArea()">
            <span>{{ portalPoint().name | localizedString }}</span>
          </div>
        }

        @if (portalPoint().icon) {
          <cue-icon
            class="map-btn-icon-wrapper"
            [class.isNextPortal]="!isFirstPortalOfArea()"
            [class.map-btn-icon-wrapper--animated]="!isPanel"
            [icon]="portalPoint().icon"
            [customIconClass]="'map-btn-icon'"
          />
        }

        @if (!portalPoint().icon) {
          <cue-icon
            class="map-btn-icon-wrapper"
            [class.isNextPortal]="!isFirstPortalOfArea()"
            [class.map-btn-icon-wrapper--animated]="!isPanel"
            [icon]="ICONS.cueCircle"
            [customIconClass]="'map-btn-iconDef'"
          />
        }
      </div>
    }
  </div>
</cue-declarative-map-marker>
